if (!customElements.get('infinite-scroll-loader')) {
  class InfiniteScrollLoader extends HTMLElement {
    constructor() {
      super();
      this.onIntersection = this.onIntersection.bind(this);
      this.isLoading = false;
    }

    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl || '';
      this.sectionId = this.dataset.sectionId || '';
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      this.spinner = this.querySelector('.infinite-scroll-loader__spinner');
      this.statusElement = this.querySelector('[data-infinite-scroll-status]');

      if (!this.nextUrl || !this.grid) {
        return;
      }

      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '600px 0px 600px 0px',
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    onIntersection(entries) {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (isVisible && !this.isLoading && this.nextUrl) {
        this.loadNextPage();
      }
    }

    loadNextPage() {
      this.isLoading = true;
      if (this.observer) this.observer.disconnect();
      if (this.spinner) this.spinner.hidden = false;

      const separator = this.nextUrl.includes('?') ? '&' : '?';
      const fetchUrl = this.sectionId
        ? `${this.nextUrl}${separator}section_id=${this.sectionId}`
        : this.nextUrl;

      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = parsedHTML.querySelector('#product-grid');
          const newLoader = parsedHTML.querySelector('infinite-scroll-loader');

          let addedCount = 0;
          if (newGrid && this.grid) {
            Array.from(newGrid.children).forEach((item) => {
              this.grid.appendChild(item);
              addedCount += 1;
            });
          }

          if (this.statusElement && addedCount > 0) {
            this.statusElement.textContent = `Se cargaron ${addedCount} productos más`;
          }

          this.nextUrl = newLoader ? newLoader.dataset.nextUrl || '' : '';
          this.isLoading = false;

          if (this.nextUrl) {
            if (this.spinner) this.spinner.hidden = true;
            this.observer.observe(this);
          } else {
            this.remove();
          }
        })
        .catch(() => {
          this.isLoading = false;
          if (this.spinner) this.spinner.hidden = true;
          if (this.observer) this.observer.observe(this);
        });
    }
  }

  customElements.define('infinite-scroll-loader', InfiniteScrollLoader);
}
